import React from 'react'
import '../Styles/Address.css'
import { useEffect } from 'react'
import { useState } from 'react'
import api from '../api.js'
import '../Styles/CartPage/Cart.css'
import { useNavigate } from 'react-router-dom'

function AddressPage({ addressList }) {
  const [addressLists, setAddressLists] = useState([addressList]);


  const [savedAddress, setSavedAddress] = useState(false);
  const [addressId, setAddressId] = useState(null);
  const [switches, setSwitches] = useState(true);
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [number, setNumber] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [post_code, setPost_code] = useState("");
  const [paymentmode, setPaymentmode] = useState("COD");
  const [showAll, setShowAll] = useState(false);

  const accessToken = localStorage.getItem('accessToken');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  if(addressList !== 0){
    setSavedAddress(true);
  }

  const handleCancelAddress = () => {
    navigate("/profile/address");

  }
  const handleAddAddress = () => {
    setSavedAddress(!savedAddress);

  }



  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(0);

  const totalPages = Math.ceil((addressLists?.length || 0) / itemsPerPage);


  const startIndex = currentPage * itemsPerPage;
  const visibleItems = addressLists?.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages - 1) setCurrentPage(currentPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };



  const formData = {
    first_name,
    last_name,
    number,
    address,
    city,
    state,
    post_code
  };
  const submitAddress = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post(`/user_api/checkout/post-address?access_token=${JSON.parse(accessToken)}`, formData);
      console.log(response.data.message);
      alert(response.data.message);
      if (response.data.message === "Address has been saved successfully") {

        setSavedAddress(true);
      } else {
        setSavedAddress(false);
      }



      setSwitches(true);

    } catch (error) {
      console.error('Error adding address:', error);

    }
  }
  useEffect(() => {
    
    if(savedAddress){

 
      const callAddressApi = async () => {
        try {
          const response = await api.get(`/user_api/checkout/get-checkout-details?access_token=${JSON.parse(accessToken)}`);
          setAddressLists(response.data.address);
          console.log("Fetched address list after switching to saved addresses", response.data.address);
        } catch (error) {
          console.error('Error fetching saved addresses:', error);
        }
      };
      callAddressApi();
    }},

  [savedAddress]);







  return (
    <>
      {
         addressLists===0 ?

          <form className='Form_div'>
            <div className='Form_parent_div shadow'>
              <div className='Form_parent_div_child'>
                <label>First Name: </label>
                <input type="text" name="first_name" value={first_name} onChange={(e) => setFirst_name(e.target.value)} required={true} />
              </div>
              <div className='Form_parent_div_child'>
                <label>Last Name: </label>
                <input type="text" name="last_name" value={last_name} onChange={(e) => setLast_name(e.target.value)} required />
              </div>

            </div>
            <div className='Form_parent_div shadow'>
              <div className='Form_parent_div_child'>
                <label>Phone Number: </label>
                <input type="number" name="first_name" value={number} onChange={(e) => setNumber(e.target.value)} required />
              </div>
              <div className='Form_parent_div_child'>
                <label>Zip: </label>
                <input type="number" value={post_code} onChange={(e) => setPost_code(e.target.value)} required />
              </div>

            </div>
            <div className='Form_parent_div shadow'>
              <div className='Form_parent_div_child'>
                <label>Address: </label>
                <input type="text" name="address" value={address} onChange={(e) => setAddress(e.target.value)} required />
              </div>
              <div className='Form_parent_div_child'>
                <label>Set It Default Address:</label>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <input type="radio" name="default_address" style={{ width: "20px", height: "20px" }} /><span>Yes</span></div>
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> <input type="radio" name="default_address" style={{ width: "20px", height: "20px" }} /><span>No</span></div>
                </div>

              </div>
            </div>
            <div className='Form_parent_div shadow' >

              <div className='Form_parent_div_child'>
                <section>State:</section>
                <select required value={state} onChange={(e) => setState(e.target.value)}>
                  <option value="India">WB</option>
                  <option value="USA">Delhi</option>
                  <option value="UK">UP</option>
                  <option value="Canada">Mumbai</option>
                </select>
              </div>
              <div className='Form_parent_div_child'>
                <section>City: </section>
                <select required value={city} onChange={(e) => setCity(e.target.value)}>
                  <option value="India">Kalyani</option>
                  <option value="USA">Krishnanagar</option>
                  <option value="UK">Birhumpore</option>
                  <option value="Canada">Kolkata</option>
                </select>
              </div>



            </div>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>

              <button className='botton_style_submit shadow' onClick={submitAddress}>Save Address</button>
              <span className='Cancel_div' onClick={handleCancelAddress}>Cancel</span>
            </div>


          </form>


          :
          <>
                <div className='SavedAddress_div'>
                  <div style={{ display: "flex", justifyContent: "flex-start", paddingLeft: "4%" }}><button className='btn btn-success' style={{ padding: "10px 20px" }} onClick={handleAddAddress}>+Add Address</button></div>
                  <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "20px" }}>
                    <div className='address_list_div addressList_background' >
                      <div>
                        {addressLists?.slice(0,1).map((item) => (
                          <div className='Default_address_style_div' style={{ padding: "5px" }}>
                            <div style={{ fontWeight: "600", fontSize: "18px" }}>Default Address: </div>
                            <div className='default_address'>
                              <span><input type='radio' id='radio_id' checked /></span>
                              <span className='address_name'>
                                <span>{item.first_name}</span>
                                <span>+91 {item.number}</span>
                                <span className='address_name_main'> {item.address},{item.city},{item.post_code},{item.state}</span>
                              </span>

                            </div>
                          </div>

                        ))}

                      </div>

                      <div>

                        <div className='Default_address_style_div' style={{ padding: "5px" }}>
                          <div style={{ fontWeight: "600", fontSize: "18px" }}>More Addresses: </div>
                          {visibleItems.map((item, index) => (
                            <div className='default_address' key={index}>
                              <span><input type='radio' id='radio_id' /></span>
                              <span className='address_name'>
                                <span>{item.first_name}</span>
                                <span>+91 {item.number}</span>
                                <span className='address_name_main'>
                                  {item.address}, {item.city}, {item.post_code}, {item.state}
                                </span>
                              </span>
                            </div>
                          ))}

                          {/* Pagination Buttons */}
                          <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                            <button
                              className='btn btn-secondary'
                              onClick={handlePrevious}
                              disabled={currentPage === 0}
                            >
                              Previous Addresses
                            </button>

                            <button
                              className='btn btn-primary'
                              onClick={handleNext}
                              disabled={currentPage >= totalPages - 1}
                            >
                              Next to more Address
                            </button>
                          </div>
                        </div>



                      </div>

                    </div>
                  </div>
                </div>
            

          </>


      }

    </>
  )
}

export default AddressPage